// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"dd074ea8","453":"09197a89"}[chunkId] + ".chunk.js";
};